import { Link } from 'gatsby';
import React from 'react';

export default function NavButtons(props) {
  return <div>
      <div className="absolute z-10" style={{right: 0, bottom: props.bottom, display: props.display}}>  
        <Link to={props.navigateTo}>
          <button
            className="p-3 rounded-full shadow-lg text-md text-white m-2 -mt-3 bg-shona"
          >
              <div>{props.title}</div>
          </button>
          </Link>
        </div>
  </div>;
}
